'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var scroll = require('../ui/scroll.js');

basePage.init = function() {
	basePage.initBasePage();

	var termsSupplied = $('#carFinanceLandingPage').data('termsSupplied');
	if (termsSupplied){
		scroll.scrollTo($('.car-finance__partner__top-link'), 'fast');
	}
};

module.exports = basePage; 